import { render, staticRenderFns } from "./Confirmation.vue?vue&type=template&id=6b9b7849"
import script from "./Confirmation.vue?vue&type=script&lang=js"
export * from "./Confirmation.vue?vue&type=script&lang=js"
import style0 from "./Confirmation.vue?vue&type=style&index=0&id=6b9b7849&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports